import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minEndAtValidator(minEndAt: Date, days: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = <Date | null>control.value;
        if (!value) {
            return null;
        }
        return value.getTime() >= minEndAt.getTime() ? null : { minDate: { days } };
    };
}
